import React from 'react';
import Modal from '../../Atoms/Modal/Modal';
import styles from './EventInfoModal.module.scss';
import calendarIcon from '../../../assets/Imagess/calendar-black.svg';
import Buttons from '../../Atoms/Buttons/Buttons';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import noImageFound from '../../../assets/Imagess/no-image-found.jpg';
import he from 'he';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';
const NewsInfoModal = ({ news, handleOnClose, setShowDeletePopup }) => {
  const navigate = useNavigate();

  return (
    <Modal
      onClose={handleOnClose}
      width="559px"
      modalInnerContainerStyle={{ padding: '0px', gap: '0px' }}
    >
      <div>
        <img
          src={sanitizeAndValidateUrl(`${news?.url}${news?.image}`)}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = noImageFound;
          }}
          className={styles['modal-image']}
        />
      </div>
      <div className={styles['title-container']}>
        <p className={styles['title']}>{news?.title_AR}</p>
      </div>
      <div className={styles['info-container']}>
        <p className={styles['category-name']}>{news?.category_AR}</p>
        <div className={styles['date-time-container']}>
          <div className={styles['date-time-item']}>
            <p>{moment(news?.newsDate).format('DD/MM/yyyy')}</p>
            <img src={calendarIcon} />
          </div>
        </div>
        <div
          className={styles['date-time-container']}
          style={{ marginTop: '16px', marginBottom: '16px' }}
        >
          <div className={styles['date-time-item']}>
            <p
              className={styles['value']}
              style={{ overflowY: 'scroll', maxHeight: '25vh' }}
              dangerouslySetInnerHTML={{
                __html: he.decode(news?.newsTextAr),
              }}
            />
          </div>
        </div>
        <div className={styles['text-container']}>
          {/* <p className={styles["text"]}>{news?.newsTextEN}</p> */}
          {/* <p
                className={styles["value"]}
                style={{ overflowY: "scroll", maxHeight: "25vh" }}
                dangerouslySetInnerHTML={{
                  __html: he.decode(news?.newsTextEN || "")
                }}
              /> */}
        </div>
        <div className={styles['button-container']}>
          <Buttons
            text="تعديل"
            color="#0DA06E"
            rounded={true}
            style={{ width: '100%' }}
            type="submit"
            handleOnClick={() => navigate(`/home/edit-news/${news?.newsId}`)}
          />
          <Buttons
            text="حذف"
            color="#D72222"
            rounded={true}
            style={{ width: '100%' }}
            type="submit"
            handleOnClick={() => {
              handleOnClose();
              setShowDeletePopup(true);
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default NewsInfoModal;
